import React from "react";
import PrimaryCard, { PrimaryCardProps } from "./PrimaryCard";
import SecondaryCard, { SecondaryCardProps } from "./SecondaryCard";
import { UCLColorKey } from "../colors/uclColors";

export interface SelectableCardOption {
  key: string;
  headerContent: React.ReactNode;
  cardContent?: React.ReactNode;
  icon?: React.ReactNode;
  [extra: string]: any;
}

export interface SelectableCardGroupProps {
  options: SelectableCardOption[];
  value: string | string[] | null;
  onChange: (key: string | string[]) => void;
  cardType?: "primary" | "secondary";
  color?: UCLColorKey;
  className?: string;
  style?: React.CSSProperties;
  cardProps?: PrimaryCardProps | SecondaryCardProps;
  multiSelect?: boolean;
}

const SelectableCardGroup: React.FC<SelectableCardGroupProps> = ({
  options,
  value,
  onChange,
  cardType = "primary",
  color,
  className,
  style,
  cardProps = {},
  multiSelect = false,
}) => {
  const CardComponent = cardType === "secondary" ? SecondaryCard : PrimaryCard;
  const selectedKeys = multiSelect && Array.isArray(value)
    ? value
    : typeof value === "string"
      ? [value]
      : [];

  const handleSelect = (key: string) => {
    if (multiSelect) {
      let newSelected: string[] = Array.isArray(value) ? [...value] : [];
      if (newSelected.includes(key)) {
        newSelected = newSelected.filter((k) => k !== key);
      } else {
        newSelected.push(key);
      }
      onChange(newSelected);
    } else {
      onChange(key);
    }
  };

  return (
    <div className={className} style={{ display: "flex", gap: "2rem", ...style }}>
      {options.map((opt) => (
        <CardComponent
          key={opt.key}
          headerContent={opt.headerContent}
          selected={selectedKeys.includes(opt.key)}
          onSelect={() => handleSelect(opt.key)}
          color={color}
          {...cardProps}
        >
          <div className="selectable-card-group__card-content">
            {opt.icon && <div className="selectable-card-group__icon">{opt.icon}</div>}
            {opt.cardContent && <div className="selectable-card-group__desc">{opt.cardContent}</div>}
          </div>
        </CardComponent>
      ))}
    </div>
  );
};

export default SelectableCardGroup; 